import { Type } from 'class-transformer';
import {
  IsBoolean,
  IsEmail,
  IsNumber,
  IsOptional,
  IsString,
  Max,
  MaxLength,
  Min,
  MinLength
} from 'class-validator';
import { MAX_DIGITAL_CARD_AMOUNT, MIN_DIGITAL_CARD_AMOUNT } from '../../constants';
import { GiftCardSalesChannelDto } from '../giftCardSalesChannel.dto';
import { PaymentDto } from '../payment.dto';
import { GiftCardPromotionDto } from './giftCardPromotion.dto';
import { GiftCardReasonDto } from './giftCardReason.dto';
import { GiftCardTypeDto } from './giftCardType.dto';

export class GiftCardGenerateRequestDto {
  @IsBoolean()
  @IsOptional()
  public acceptTerms?: boolean;

  @IsBoolean()
  @IsOptional()
  public acceptsMarketingTerms?: boolean;

  @IsNumber()
  @Max(MAX_DIGITAL_CARD_AMOUNT)
  @Min(MIN_DIGITAL_CARD_AMOUNT)
  public cardValue: number;

  @MaxLength(255)
  @IsEmail()
  public customerEmail: string;

  @MaxLength(255)
  public customerName: string;

  @IsOptional()
  @IsNumber()
  public deliveryDateAsInt?: number;

  @IsOptional()
  @IsBoolean()
  public enableSendEmails?: boolean;

  @MaxLength(255)
  @IsEmail()
  public fromEmail: string;

  @MaxLength(255)
  public fromName: string;

  @IsOptional()
  @Type(() => GiftCardPromotionDto)
  public giftCardPromotion?: GiftCardPromotionDto;

  @IsOptional()
  @Type(() => GiftCardReasonDto)
  giftCardReason?: GiftCardReasonDto;
  @Type(() => GiftCardTypeDto)
  public giftCardType: GiftCardTypeDto;
  @Type(() => GiftCardSalesChannelDto)
  giftCardSalesChannel?: GiftCardSalesChannelDto;

  lastModifiedUserId?: number;
  @IsNumber()
  public merchantId: number;

  @MaxLength(160)
  @IsString()
  @IsOptional()
  public message?: string;

  @IsString()
  @IsOptional()
  @MaxLength(300)
  public note?: string;

  @Type(() => PaymentDto)
  @IsOptional()
  public payment?: PaymentDto;

  @IsBoolean()
  public sendCopyToPurchaser: boolean;

  @IsBoolean()
  public isStaffCard: boolean;
}
